import {useEffect} from 'react';

export const CloseTab = () => {
    useEffect(() => {
        window.open('', '_parent', '');
        window.close();
    }, []);

    return null;
};
